.title {
  padding-top: var(--space-xs);
  font-size: var(--font-size-s);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
